import React from "react";
import "./timeline.css";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import One from '../../../assets/images/one.svg';
import Two from '../../../assets/images/two.svg';
import Three from '../../../assets/images/three.svg';
import Four from '../../../assets/images/four.svg';
import Five from '../../../assets/images/five.svg';
import Six from '../../../assets/images/six.svg';
import Seven from '../../../assets/images/seven.svg';
import Eight from '../../../assets/images/eight.svg';


function TimelineSignature() {
    return (
        <div id="timelineProfiler" >
            <Timeline position="alternate">
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content"
                    >
                        <h3>Sleep apnea risk</h3>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector sx={{ bgcolor: '#ffffff' }} />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={One} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >
                        <p>Understand how your current sleep habit influences your risk towards sleep apnea </p>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-content"
                    >
                        <p>Discover your resting heart rate and gain insights into its capacity for exertion​</p>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Two} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-opposite-content">
                        <h3>Heart rate analysis</h3>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content"
                    >
                        <h3>Cardiorespiratory rhythm</h3>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Three} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >
                        <p>Uncover the efficiency of your body's self-healing capabilities, determined by the coordination between your heart and lungs </p>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-content"
                    >
                        <p>Heart Age offers insight into how your heart's age compares to your chronological age, providing an understanding of potential cardiac risks </p>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img className='numbers-icon' src={Four} alt="Profiler" />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-opposite-content">
                        <h3>Heart age</h3>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content"
                    >
                        <h3>Endurance and Recovery</h3>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot className="timeline-dot" variant="outlined" >
                            <img alt="Profiler" className='numbers-icon' src={Five}  />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >
                        <p>Uncover your peak aerobic capacity and understand your recovery, indicating your heart tolerance towards high-intensity workouts</p>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-content"
                    >
                        <p>We identify early signs in your mind and body that may lead to stress, anxiety or depression in the future and provide guidance on how to address them</p>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Six} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector className="timeline-connector" />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-opposite-content">
                        <h3>Mental health assessments</h3>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem className="timeline-item">
                    <TimelineOppositeContent
                        className="timeline-opposite-content"
                    >
                        <h3>BEATS Report</h3>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineConnector className="timeline-connector" />
                        <TimelineDot variant="outlined" className="timeline-dot">
                            <img src={Seven} alt="Profiler" className='numbers-icon' />
                        </TimelineDot>
                        <TimelineConnector sx={{ bgcolor: '#ffffff' }} />
                    </TimelineSeparator>
                    <TimelineContent className="timeline-content" >
                        <p>We integrate your resting and reactive heart patterns to create a comprehensive heart blueprint. This includes conducting over 40 checks for irregularities, offering tailored recommendations, and providing a detailed report that offers a clear view of your heart health, complete with actionable guidance.</p>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        </div>

    );
}

export default TimelineSignature;